import { render, staticRenderFns } from "./DoctorsRevenueReport.vue?vue&type=template&id=2d07e52c&scoped=true"
import script from "./DoctorsRevenueReport.vue?vue&type=script&lang=js"
export * from "./DoctorsRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./DoctorsRevenueReport.vue?vue&type=style&index=0&id=2d07e52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d07e52c",
  null
  
)

export default component.exports